'use client'
import {
  context_default
} from "./chunk-5YBTZVAT.mjs";

// src/UiProvider/useUi.ts
import { useContext } from "react";
var useUi = () => {
  const context = useContext(context_default);
  if (!context) {
    throw new Error("useUi must be used within a UiProvider");
  }
  return context;
};

export {
  useUi
};
//# sourceMappingURL=chunk-Y3GT52GT.mjs.map